(function () {
  var STYLE_ID = 'incrystal-forms-width-style';
  var DESKTOP_WIDTH = '720px';
  function injectShadowStyle(shadow) {
    if (!shadow || shadow.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      ':host{--inline-container-max-width:720px!important;width:100%!important;max-width:720px!important;}' +
      '[class*="_inline_"],[class*="_noImage_"],[class*="_formContainer_"],form{width:100%!important;max-width:720px!important;box-sizing:border-box!important;}' +
      '@media(max-width:749px){:host,[class*="_inline_"],[class*="_noImage_"],[class*="_formContainer_"],form{width:100%!important;max-width:100%!important;}}';
    shadow.appendChild(style);
  }
  function widenRoot(root) {
    root.style.setProperty('--inline-container-max-width', DESKTOP_WIDTH, 'important');
    root.style.setProperty('width', '100%', 'important');
    root.style.setProperty('max-width', DESKTOP_WIDTH, 'important');
    root.style.setProperty('margin-inline', 'auto', 'important');
    var block = root.closest('.shopify-app-block');
    if (block) {
      block.style.setProperty('width', '100%', 'important');
      block.style.setProperty('max-width', DESKTOP_WIDTH, 'important');
      block.style.setProperty('margin-inline', 'auto', 'important');
    }
    var nodes = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
    nodes.forEach(function (node) {
      if (node.tagName === 'FORM-EMBED' || (node.tagName && node.tagName.indexOf('-') !== -1)) {
        node.style.setProperty('--inline-container-max-width', DESKTOP_WIDTH, 'important');
        node.style.setProperty('width', '100%', 'important');
        node.style.setProperty('max-width', DESKTOP_WIDTH, 'important');
      }
      if (node.shadowRoot) {
        injectShadowStyle(node.shadowRoot);
        var form = node.shadowRoot.querySelector('form');
        if (form) {
          form.style.setProperty('width', '100%', 'important');
          form.style.setProperty('max-width', DESKTOP_WIDTH, 'important');
          var parent = form.parentElement;
          while (parent) {
            parent.style.setProperty('width', '100%', 'important');
            parent.style.setProperty('max-width', DESKTOP_WIDTH, 'important');
            parent = parent.parentElement;
          }
        }
      }
    });
  }
  function apply() {
    document.querySelectorAll('[data-form-root]').forEach(widenRoot);
  }
  function start() {
    apply();
    new MutationObserver(apply).observe(document.documentElement, {childList:true,subtree:true});
    var attempts = 0;
    var timer = window.setInterval(function () {
      apply();
      attempts += 1;
      if (attempts >= 30) window.clearInterval(timer);
    }, 500);
    window.addEventListener('resize', apply);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();